const COLORS: Record<string, string> = {
  low: 'badge-success',
  medium: 'badge-warning',
  high: 'badge-error',
};

interface LevelBadgeProps {
  level: string;
  label?: string;
  variant?: 'pill' | 'chip';
}

export function LevelBadge({ level, label, variant = 'pill' }: LevelBadgeProps) {
  const normalized = level.toLowerCase();
  const color = COLORS[normalized] ?? '';
  const shape = variant === 'pill' ? 'rounded-full' : 'rounded';
  const text = label ?? level;
  return (
    <span className={`inline-block px-2.5 py-0.5 text-xs font-medium capitalize ${shape} ${color}`}>
      {text}
    </span>
  );
}
